import { Loader, Popover } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { UserFields } from "../types/user.types";
import Contact from "./contacts/Contact";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { mtsUrl } from "../lib/mts-url";
import { useRef } from "react";
import { ContactFields } from "../types/contact.types";
import UserAvatar from "./UserAvatar";

interface UserAvatarProps {
  user: UserFields | ContactFields;
}

export default function UserAvatarWithCard({ user }: UserAvatarProps) {
  const [opened, { close, open }] = useDisclosure(false);
  const queryEnabled = useRef(false);
  const query = useQuery({
    queryKey: ['users', user.id],
    queryFn: () => axios.get(mtsUrl(`users/${user.id}`)).then(r => r.data),
    enabled: queryEnabled.current
  });

  return (
    <Popover opened={opened}>
      <Popover.Target>
        <div>
          <UserAvatar
            user={user}
            onMouseEnter={() => {
              queryEnabled.current = true;
              open();
            }}
            onMouseLeave={close}
          />
        </div>
      </Popover.Target>
      <Popover.Dropdown p={0}>
        {(query.isSuccess && query.data) ? (
          <Contact contact={query.data} withBorder={false} />
        ) : (
          <Loader p="md" size="sm" />
        )}
      </Popover.Dropdown>
    </Popover>
  )
}